
import {Component, Vue} from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {INTERNATIONAL_TRADE_TERMS, LADING_TYPE, PAYMENT_TYPE,} from "@/constant";
import ExchangeRateForm from "./ExchangeRateForm.vue";
import PriceClassForm from "./PriceClassForm.vue";
import CfDetail from "./CfDetail.vue";
import {PcQuery} from "@/api/priceclass/types";
import {changeStatus, page} from "@/api/priceclass";
import CfForm from "@/views/system-management/information/financial/CfForm.vue";

@Component({
  name: "FinancialBookingOrderManagement",
  components: {
    CfForm,
    Pagination,
    ExchangeRateForm,
    PriceClassForm,
    CfDetail,
  },
  methods: {
    PAYMENT_TYPE,
    INTERNATIONAL_TRADE_TERMS,
    LADING_TYPE,
  },
})
export default class extends Vue {
  public searchForm = [
    {
      label: "定价等级",
      prop: "name",
      key: "name",
      type: "input",
      value: "",
      placeholder: "请输入定价等级",
    },
    {
      label: "系数名称",
      prop: "cfName",
      key: "cfName",
      type: "input",
      value: "",
      placeholder: "请输入系数名称"
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      type: "select",
      value: "",
      placeholder: "全部",
      options: [
        {
          desc: '使用中',
          name: 'true'
        },
        {
          desc: '弃用',
          name: 'false'
        },
        {
          desc: '全部',
          name: null
        }
      ],
      resetKey: {label: "desc", value: "name"},
    },
  ];


  public tableCol = [
    {
      label: "定价等级",
      prop: "name",
      key: "name",
      show: true,
      disabled: false,
    },
    {
      label: "系数名称",
      prop: "cfNames",
      key: "cfNames",
    },
    {
      label: "状态",
      prop: "status",
      key: "status",
      render: (value) => {
        if (value) {
          return '使用中'
        }
        return '弃用'
      },
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "启用",
          code: "",
          click: "handleEnable",
          show: row => {
            return row.name !== 'T0' && !row.status && row.name !== 'D'
          }
        },
        {
          name: "弃用",
          code: "",
          click: "handleUnable",
          show: row => {
            return row.name !== 'T0' && row.status && row.name !== 'D'
          }
        },
        {
          name: "详情",
          code: "",
          click: "handleDetails",
          show: row => {
            return row.name !== 'T0' && row.name !== 'D'
          }
        }
      ],
      show: true,
      disabled: false,
      width: 260,
    }
  ]
  private listParam: PcQuery = {
    name: null,
    cfName: null,
    status: null
  };
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [],
  };


  private openExchangeRateForm() {
    (this.$refs['exchangeRateForm'] as ExchangeRateForm).show();
  }

  private openPriceClassForm() {
    (this.$refs['priceClassForm'] as PriceClassForm).show();
  }

  public querySearch(data) {
    this.table.pageNumber = 1;
    this.listParam = data && data !== "reset" ? data : {};
    this.getList();
  }

  private async getList() {
    const {total, content}: any = await page(
        this.listParam, {pageNumber: this.table.pageNumber, pageSize: this.table.pageSize})

    this.table.total = total;
    this.table.list = content;
  }

  private handleEnable({row}) {
    this.$confirm("确认启用？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      return changeStatus(row.id, true);
    }).then(() => {
      this.getList();
    }).catch(() => {
      console.log('取消');
    });
  }

  private handleUnable({row}) {
    this.$confirm("确认弃用？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    }).then(() => {
      return changeStatus(row.id, false);
    }).then(() => {
      this.getList();
    }).catch(() => {
      console.log('取消');
    });
  }

  private handleDetails({row}) {
    (this.$refs['cfDetail'] as CfDetail).show(row);
  }

  created() {
    this.getList()
  }
}
